module.exports = __webpack_public_path__ + "static/media/tour-vip.b8a29a33.svg";